// extracted by mini-css-extract-plugin
export default {"text_wrapper":"EllipsisTextLine_text_wrapper__lA3Ub"};